import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEocTabIVE as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEocTabIVE = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const e1Field = () => {
    const propertyName = pn<AprResponseModel>("e1");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.e1}{" "}
        {formatPercentTotal(props.data?.e1, props.data?.e8)}
      </DataDisplay>
    );
  };

  const e2Field = () => {
    const propertyName = pn<AprResponseModel>("e2");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.e2}{" "}
        {formatPercentTotal(props.data?.e2, props.data?.e8)}
      </DataDisplay>
    );
  };

  const e3Field = () => {
    const propertyName = pn<AprResponseModel>("e3");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.e3} {formatPercentTotal(props.data?.e3, props.data?.e8)}
      </DataDisplay>
    );
  };

  const e4Field = () => {
    const propertyName = pn<AprResponseModel>("e4");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.e4} {formatPercentTotal(props.data?.e4, props.data?.e8)}
      </DataDisplay>
    );
  };

  const e5Field = () => {
    const propertyName = pn<AprResponseModel>("e5");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.e5} {formatPercentTotal(props.data?.e5, props.data?.e8)}
      </DataDisplay>
    );
  };

  const e6Field = () => {
    const propertyName = pn<AprResponseModel>("e6");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.e6} {formatPercentTotal(props.data?.e6, props.data?.e8)}
      </DataDisplay>
    );
  };

  const e7Field = () => {
    const propertyName = pn<AprResponseModel>("e7");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.e7} {formatPercentTotal(props.data?.e7, props.data?.e8)}
      </DataDisplay>
    );
  };

  const e8Field = () => {
    const propertyName = pn<AprResponseModel>("e8");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.e8}</DataDisplay>
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Postsecondary Placements (Types of Institutions)</Typography>
        <Grid container spacing="lg">
          <Grid item xs={11}>
            <Grid container spacing="lg">
              {props.data?.e1 != null && (
                <Grid item xs={12}>
                  {e1Field()}
                </Grid>
              )}
              <GridBreak />

              {props.data?.e2 != null && (
                <Grid item xs={12}>
                  {e2Field()}
                </Grid>
              )}

              {props.data?.e3 != null && (
                <Grid item xs={12}>
                  {e3Field()}
                </Grid>
              )}

              {props.data?.e4 != null && (
                <Grid item xs={12}>
                  {e4Field()}
                </Grid>
              )}
              {props.data?.e5 != null && (
                <Grid item xs={12}>
                  {e5Field()}
                </Grid>
              )}

              {props.data?.e6 != null && (
                <Grid item xs={12}>
                  {e6Field()}
                </Grid>
              )}

              {props.data?.e7 != null && (
                <Grid item xs={12}>
                  {e7Field()}
                </Grid>
              )}

              {props.data?.e8 != null && (
                <Grid item xs={12}>
                  {e8Field()}
                </Grid>
              )}
              <GridBreak />
            </Grid>
          </Grid>

        </Grid>
      </Stack>
    </Card>
  );
};
